(function () {
  // =========================================================
  // CUSTOM CART PROGRESS V2
  // Cart Drawer + Cart Page
  // =========================================================

  let updateTimer = null;
  let observer = null;


  // =========================================================
  // MONEY
  // =========================================================

  function formatMoney(amount) {
    const cents = Math.round(amount * 100);

    if (
      window.Shopify &&
      typeof window.Shopify.formatMoney === 'function'
    ) {
      try {
        return window.Shopify.formatMoney(
          cents,
          window.theme && window.theme.moneyFormat
            ? window.theme.moneyFormat
            : undefined
        );
      } catch (error) {
        // fallback
      }
    }

    return amount.toFixed(2).replace('.', ',') + '€';
  }


  // =========================================================
  // MESSAGE
  // =========================================================

  function buildMessage(message, amount) {
    if (!message) {
      return '';
    }

    return message.replace(
      '||amount||',
      '<span data-left-to-spend>' +
        '<b class="atteintPrice">' +
          formatMoney(amount) +
        '</b>' +
      '</span>'
    );
  }


  // =========================================================
  // FIND ALL PROGRESS COMPONENTS
  // =========================================================

  function getProgressContainers() {
    const elements = document.querySelectorAll(
      '[data-cart-message-v2], .custom-progress-container'
    );

    const unique = [];

    elements.forEach(function (element) {
      /*
       * Avoid duplicate processing if a
       * .custom-progress-container contains
       * [data-cart-message-v2].
       */
      const parentCustom =
        element.parentElement
          ? element.parentElement.closest(
              '.custom-progress-container'
            )
          : null;

      if (
        element.matches('[data-cart-message-v2]') &&
        parentCustom
      ) {
        return;
      }

      if (!unique.includes(element)) {
        unique.push(element);
      }
    });

    return unique;
  }


  // =========================================================
  // SETTINGS
  // =========================================================

  function getProgressSettings(container) {
    if (!container) {
      return null;
    }

    /*
     * Settings may be on the container itself,
     * or on its child message element.
     */
    let settingsElement = container;

    if (
      !settingsElement.hasAttribute(
        'data-shipping-limit'
      )
    ) {
      const child = container.querySelector(
        '[data-shipping-limit]'
      );

      if (child) {
        settingsElement = child;
      }
    }


    const shippingLimit = parseFloat(
      settingsElement.dataset.shippingLimit || '0'
    );

    const freeProductLimit = parseFloat(
      settingsElement.dataset.freeProductLimit || '0'
    );

    const shippingMessage =
      settingsElement.dataset.shippingMessage || '';

    const shippingSuccessMessage =
      settingsElement.dataset.shippingSuccessMessage || '';

    const freeProductMessage =
      settingsElement.dataset.freeProductMessage || '';

    const freeProductSuccessMessage =
      settingsElement.dataset.freeProductSuccessMessage || '';


    return {
      container,
      settingsElement,

      shippingLimit,
      freeProductLimit,

      shippingMessage,
      shippingSuccessMessage,

      freeProductMessage,
      freeProductSuccessMessage
    };
  }


  // =========================================================
  // ACTIVE STEPS
  // =========================================================

  function getSteps(settings) {
    const steps = [];


    // FREE SHIPPING
    if (
      settings.shippingLimit > 0 &&
      settings.shippingMessage.trim() !== ''
    ) {
      steps.push({
        type: 'shipping',
        limit: settings.shippingLimit,
        message: settings.shippingMessage,
        successMessage:
          settings.shippingSuccessMessage
      });
    }


    // FREE PRODUCT
    if (
      settings.freeProductLimit > 0 &&
      settings.freeProductMessage.trim() !== ''
    ) {
      steps.push({
        type: 'free-product',
        limit: settings.freeProductLimit,
        message: settings.freeProductMessage,
        successMessage:
          settings.freeProductSuccessMessage
      });
    }


    // Lowest threshold first
    steps.sort(function (a, b) {
      return a.limit - b.limit;
    });


    return steps;
  }


  // =========================================================
  // CURRENT STEP
  // =========================================================

  function getCurrentStep(total, steps) {
    for (let i = 0; i < steps.length; i++) {
      if (total < steps[i].limit) {
        return {
          completed: false,
          step: steps[i],
          index: i
        };
      }
    }


    if (steps.length) {
      return {
        completed: true,
        step: steps[steps.length - 1],
        index: steps.length - 1
      };
    }


    return null;
  }


  // =========================================================
  // PROGRESS
  // =========================================================

function calculateProgress(
  total,
  steps,
  container
) {
  if (!steps.length) {
    return 0;
  }


  /*
   * One target only:
   * regular 0 → 100 progression.
   */
  if (steps.length === 1) {
    let percent =
      (total / steps[0].limit) * 100;

    if (percent > 100) {
      percent = 100;
    }

    if (percent < 0) {
      percent = 0;
    }

    return percent;
  }


  const firstStep = steps[0];
  const secondStep = steps[1];


  let firstPosition = parseFloat(
    container.dataset.firstMarkerPosition || '40'
  );

  let secondPosition = parseFloat(
    container.dataset.secondMarkerPosition || '78'
  );


  if (firstPosition < 0) {
    firstPosition = 0;
  }

  if (secondPosition > 100) {
    secondPosition = 100;
  }


  let percent = 0;


  /*
   * First segment
   */
  if (total < firstStep.limit) {

    percent =
      (total / firstStep.limit) *
      firstPosition;

  }


  /*
   * Between first and second target
   */
  else if (total < secondStep.limit) {

    const amountInsideSegment =
      total - firstStep.limit;

    const amountSegmentSize =
      secondStep.limit -
      firstStep.limit;

    const visualSegmentSize =
      secondPosition -
      firstPosition;


    percent =
      firstPosition +
      (
        amountInsideSegment /
        amountSegmentSize
      ) *
      visualSegmentSize;

  }


  /*
   * Both targets achieved
   */
  else {

    percent = 100;

  }


  if (percent > 100) {
    percent = 100;
  }

  if (percent < 0) {
    percent = 0;
  }


  return percent;
}


  // =========================================================
  // FINAL SUCCESS MESSAGE
  // =========================================================

  function getFinalSuccessMessage(steps) {
    if (!steps.length) {
      return '';
    }

    const finalStep =
      steps[steps.length - 1];


    if (
      finalStep.successMessage &&
      finalStep.successMessage.trim() !== ''
    ) {
      return finalStep.successMessage;
    }


    for (
      let i = steps.length - 2;
      i >= 0;
      i--
    ) {
      if (
        steps[i].successMessage &&
        steps[i].successMessage.trim() !== ''
      ) {
        return steps[i].successMessage;
      }
    }


    return 'Congratulations! All rewards unlocked!';
  }


  // =========================================================
  // FIND MESSAGE ELEMENT
  // =========================================================

  function getDefaultMessage(container) {
    return (
      container.querySelector(
        '[data-message-default-v2]'
      ) ||
      container.querySelector(
        '[data-message-default]'
      ) ||
      container.querySelector(
        '#progress-message'
      )
    );
  }


  // =========================================================
  // FIND SUCCESS MESSAGE
  // =========================================================

  function getSuccessMessage(container) {
    return container.querySelector(
      '.cart__message__success'
    );
  }


  // =========================================================
  // UPDATE MESSAGE
  // =========================================================

  function updateMessage(
    container,
    total,
    steps
  ) {
    const defaultMessage =
      getDefaultMessage(container);

    const successMessage =
      getSuccessMessage(container);


    if (!defaultMessage) {
      return;
    }


    const current =
      getCurrentStep(
        total,
        steps
      );


    defaultMessage.classList.remove(
      'is-hidden'
    );


    const messageWrapper =
      defaultMessage.closest(
        '.cart__message'
      ) || container;


    messageWrapper.classList.remove(
      'is-success'
    );


    if (successMessage) {
      successMessage.style.display =
        'none';
    }


    if (!current) {
      defaultMessage.innerHTML = '';
      return;
    }


    // =====================================================
    // ALL REWARDS ACHIEVED
    // =====================================================

    if (current.completed) {
      const finalMessage =
        getFinalSuccessMessage(
          steps
        );


      defaultMessage.classList.add(
        'is-hidden'
      );

      messageWrapper.classList.add(
        'is-success'
      );


      if (successMessage) {
        successMessage.innerHTML =
          finalMessage;

        successMessage.style.display =
          '';
      } else {
        /*
         * If Liquid did not render a success
         * element, use the default element.
         */
        defaultMessage.classList.remove(
          'is-hidden'
        );

        defaultMessage.innerHTML =
          finalMessage;
      }

      return;
    }


    // =====================================================
    // CURRENT TARGET
    // =====================================================

    const remaining =
      Math.max(
        current.step.limit - total,
        0
      );


    defaultMessage.innerHTML =
      buildMessage(
        current.step.message,
        remaining
      );
  }


  // =========================================================
  // MESSAGE CLASSES
  // =========================================================

  function updateMessageClasses(
    container,
    total,
    steps
  ) {
    const message =
      getDefaultMessage(container);


    if (!message) {
      return;
    }


    message.classList.remove(
      'shipping-step',
      'free-product-step',
      'all-achieved'
    );


    const current =
      getCurrentStep(
        total,
        steps
      );


    if (!current) {
      return;
    }


    if (current.completed) {
      message.classList.add(
        'all-achieved'
      );

      return;
    }


    if (
      current.step.type === 'shipping'
    ) {
      message.classList.add(
        'shipping-step'
      );
    }


    if (
      current.step.type === 'free-product'
    ) {
      message.classList.add(
        'free-product-step'
      );
    }
  }


  // =========================================================
  // UPDATE NATIVE PALO ALTO PROGRESS
  // =========================================================

function updateProgressBars(
  container,
  percent
) {
  const progressBars =
    container.querySelectorAll(
      '[data-cart-message-progress-v2]'
    );


  progressBars.forEach(
    function (progressBar) {

      progressBar.style.setProperty(
        '--progress-width',
        percent + '%'
      );


      /*
       * Custom V2 DIV bar
       */
      if (
        progressBar.classList.contains(
          'progress-fillV2'
        )
      ) {
        progressBar.style.width =
          percent + '%';

        return;
      }


      /*
       * Native <progress>
       */
      if (
        progressBar.tagName ===
        'PROGRESS'
      ) {
        progressBar.value =
          percent;

        progressBar.setAttribute(
          'value',
          percent
        );
      }

    }
  );
}


  // =========================================================
  // UPDATE ONE COMPONENT
  // =========================================================

  function updateSingleProgress(
    container,
    cart
  ) {
    const settings =
      getProgressSettings(
        container
      );


    if (!settings) {
      return;
    }


    const total =
      cart.total_price / 100;


    const steps =
      getSteps(
        settings
      );


    // No configured target
    if (!steps.length) {
      container.style.display =
        'none';

      return;
    }


    // Empty cart
    if (total <= 0) {
      container.style.display =
        'none';

      return;
    }


    /*
     * IMPORTANT:
     * Remove Liquid is-hidden class as well,
     * otherwise style.display alone may not
     * make the component visible.
     */
    container.style.display = '';
    container.classList.remove(
      'is-hidden'
    );


    const messageWrapper =
      container.matches(
        '.cart__message'
      )
        ? container
        : container.querySelector(
            '.cart__message'
          );


    if (messageWrapper) {
      messageWrapper.classList.remove(
        'is-hidden'
      );
    }


    // Progress percentage
  const progress =
    calculateProgress(
      total,
      steps,
      container
    );


    updateProgressBars(
      container,
      progress
    );


    updateMessage(
      container,
      total,
      steps
    );


    updateMessageClasses(
      container,
      total,
      steps
    );
  }


  // =========================================================
  // UPDATE DRAWER + CART PAGE
  // =========================================================

  function updateProgressV2(cart) {
    const containers =
      getProgressContainers();


    if (!containers.length) {
      return;
    }


    containers.forEach(
      function (container) {

        updateSingleProgress(
          container,
          cart
        );

      }
    );
  }


  // =========================================================
  // FETCH CART
  // =========================================================

  function refreshProgress(delay) {
    if (typeof delay === 'undefined') {
      delay = 120;
    }


    if (updateTimer) {
      clearTimeout(
        updateTimer
      );
    }


    updateTimer =
      setTimeout(
        function () {

          let cartUrl =
            '/cart.js';


          if (
            window.Shopify &&
            window.Shopify.routes &&
            window.Shopify.routes.root
          ) {
            cartUrl =
              window.Shopify.routes.root +
              'cart.js';
          }


          fetch(
            cartUrl,
            {
              credentials:
                'same-origin',

              cache:
                'no-store'
            }
          )
            .then(
              function (response) {

                if (!response.ok) {
                  throw new Error(
                    'Unable to load cart'
                  );
                }

                return response.json();

              }
            )
            .then(
              function (cart) {

                updateProgressV2(
                  cart
                );

              }
            )
            .catch(
              function (error) {

                console.error(
                  '[Custom progress V2]',
                  error
                );

              }
            );

        },
        delay
      );
  }


  // =========================================================
  // THEME EVENTS
  // =========================================================

  document.addEventListener(
    'theme:cart:added',
    function () {

      /*
       * Small delay because Palo Alto may
       * rebuild the drawer after the event.
       */
      refreshProgress(250);

    }
  );


  document.addEventListener(
    'theme:cart:update',
    function () {

      refreshProgress(250);

    }
  );


  // =========================================================
  // DRAWER MUTATION OBSERVER
  // =========================================================

  function observeCartDrawer() {
    const cartDrawer =
      document.querySelector(
        '[data-cart-drawer]'
      );


    if (!cartDrawer) {
      return;
    }


    if (observer) {
      observer.disconnect();
    }


    observer =
      new MutationObserver(
        function (mutations) {

          let shouldRefresh =
            false;


          mutations.forEach(
            function (mutation) {

              /*
               * VERY IMPORTANT:
               *
               * Ignore changes generated by our
               * own progress/message update.
               *
               * Otherwise innerHTML modifications
               * trigger MutationObserver again.
               */
              const target =
                mutation.target;


              if (
                target instanceof Element
              ) {

                const progressParent =
                  target.closest(
                    '.custom-progress-container, [data-cart-message-v2]'
                  );


                if (progressParent) {
                  return;
                }
              }


              if (
                mutation.type ===
                  'childList' &&
                (
                  mutation.addedNodes
                    .length > 0 ||
                  mutation.removedNodes
                    .length > 0
                )
              ) {
                shouldRefresh =
                  true;
              }

            }
          );


          if (shouldRefresh) {
            /*
             * Wait until Palo Alto has finished
             * rebuilding the drawer HTML.
             */
            refreshProgress(180);
          }

        }
      );


    observer.observe(
      cartDrawer,
      {
        childList: true,
        subtree: true
      }
    );
  }


  // =========================================================
  // INITIALIZATION
  // =========================================================

  function initProgressV2() {
    refreshProgress(0);

    observeCartDrawer();
  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initProgressV2
    );

  } else {

    initProgressV2();

  }

})();